/* EGGER fixed-length worktop configurator (layout v2).
   Price and basket come only from the real Shopify variant (finish = option1, size = option2).
   Desktop and phone share this one state, one variant lookup and one add-to-basket call. */
(function () {
  'use strict';
  var root = document.querySelector('[data-eg2]');
  if (!root) return;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var gbp = function (p) { return '£' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var phone = window.matchMedia('(max-width: 767px)');

  var variants = [];
  try { variants = JSON.parse($('[data-eg2-variants]').textContent || '[]'); } catch (e) { variants = []; }
  var T = Number(root.getAttribute('data-t')) || 20;
  var swatches = $$('.eg2-sw');
  var sizes = $$('.eg2-size');
  var state = { finish: '', size: '', qty: 1, step: 1 };

  function findVariant() {
    if (!state.finish || !state.size) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === state.finish && variants[i].option2 === state.size) return variants[i];
    }
    return null;
  }
  function dims(v) {
    var p = String(v || '').split('×').map(function (x) { return Number(String(x).trim()); });
    return { L: p[0] || 4100, W: p[1] || 650, T: p[2] || T };
  }
  function finishEl() { return swatches.filter(function (b) { return b.dataset.value === state.finish; })[0] || null; }

  /* ---------- Gallery ---------- */
  (function () {
    var track = $('[data-eg2-track]');
    if (!track) return;
    var n = track.children.length, i = 0, dots = $$('[data-eg2-dots] span'), x0 = null;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    var prev = $('[data-eg2-prev]'), next = $('[data-eg2-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    });
  })();

  /* ---------- Drawings ---------- */
  var BLUE = '#0d4f7d', GREY = '#8a98a6', INK = '#1e1e1e';
  function txt(x, y, s, o) {
    o = o || {};
    return '<text x="' + x + '" y="' + y + '" font-family="Inter, Arial, sans-serif" font-size="' + (o.size || 12) + '"' +
      (o.anchor ? ' text-anchor="' + o.anchor + '"' : '') + ' fill="' + (o.fill || INK) + '"' + (o.weight ? ' font-weight="' + o.weight + '"' : '') +
      (o.rot ? ' transform="rotate(' + o.rot + ' ' + x + ' ' + y + ')"' : '') + '>' + esc(s) + '</text>';
  }
  function arrowDefs() {
    return '<defs><marker id="eg2a" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">' +
      '<path d="M0 0 L10 5 L0 10 z" fill="' + INK + '"/></marker></defs>';
  }
  function planSvg() {
    var d = dims(state.size || (sizes[0] && sizes[0].dataset.value));
    var two = d.W >= 900, s = 540 / d.L, w = d.L * s, h = d.W * s, x = 60, y = 58;
    var sw = finishEl(), img = sw && sw.dataset.img;
    var fill = '#e9edf1', defs = arrowDefs();
    if (img) {
      defs += '<defs><pattern id="eg2p" patternUnits="userSpaceOnUse" width="' + (h * 2) + '" height="' + (h * 2) + '">' +
        '<image href="' + esc(img) + '" width="' + (h * 2) + '" height="' + (h * 2) + '" preserveAspectRatio="xMidYMid slice"/></pattern></defs>';
      fill = 'url(#eg2p)';
    }
    var H = y + h + 100, o = '<svg viewBox="0 0 700 ' + Math.round(H) + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Plan view, ' +
      d.L + ' by ' + d.W + ' millimetres, edged on ' + (two ? 'both long sides' : 'one long side') + '">' + defs;
    o += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + fill + '"/>';
    o += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="none" stroke="' + GREY + '" stroke-width="1"/>';
    o += '<line x1="' + x + '" y1="' + (y + h) + '" x2="' + (x + w) + '" y2="' + (y + h) + '" stroke="' + BLUE + '" stroke-width="5"/>';
    if (two) o += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + w) + '" y2="' + y + '" stroke="' + BLUE + '" stroke-width="5"/>';
    // Length dimension above, width dimension at the right.
    o += '<line x1="' + x + '" y1="' + (y - 30) + '" x2="' + (x + w) + '" y2="' + (y - 30) + '" stroke="' + INK + '" marker-start="url(#eg2a)" marker-end="url(#eg2a)"/>';
    o += txt(x + w / 2, y - 36, d.L + 'mm', { anchor: 'middle', weight: 700, size: 16 });
    o += '<line x1="' + (x + w + 22) + '" y1="' + y + '" x2="' + (x + w + 22) + '" y2="' + (y + h) + '" stroke="' + INK + '" marker-start="url(#eg2a)" marker-end="url(#eg2a)"/>';
    o += txt(x + w + 32, y + h / 2 + 4, d.W + 'mm', { weight: 700, size: 16 });
    o += txt(x + w / 2, y - 8, two ? 'Back: edged' : 'Back: not edged', { anchor: 'middle', size: 14, fill: two ? BLUE : '#5a5a5a' });
    o += txt(x + w / 2, y + h + 22, 'Front: edged', { anchor: 'middle', size: 14, fill: BLUE });
    o += txt(x - 8, y + h / 2 + 4, 'End', { anchor: 'end', size: 14, fill: '#5a5a5a' });
    // Legend.
    var ly = y + h + 48;
    o += '<line x1="' + x + '" y1="' + ly + '" x2="' + (x + 26) + '" y2="' + ly + '" stroke="' + BLUE + '" stroke-width="5"/>' + txt(x + 34, ly + 4, '1.5mm ABS edging', { size: 14 });
    o += '<line x1="' + (x + 200) + '" y1="' + ly + '" x2="' + (x + 226) + '" y2="' + ly + '" stroke="' + GREY + '" stroke-width="1.5"/>' + txt(x + 234, ly + 4, 'Not edged', { size: 14 });
    o += txt(x, ly + 30, state.size ? 'Shown to scale. Thickness ' + d.T + 'mm.' : 'Choose a size to see your worktop.', { size: 14, fill: '#5a5a5a' });
    return o + '</svg>';
  }
  function edgeSvg() {
    var d = dims(state.size || (sizes[0] && sizes[0].dataset.value));
    var two = d.W >= 900, k = 3.2, t = d.T * k, depth = 80 * k, abs = 1.5 * k;
    var x = 40, y = 52, xr = x + depth, base = y + t;
    var o = '<svg viewBox="0 0 420 ' + Math.round(base + 80) + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Edge profile: ' +
      d.T + 'mm thick, square edge with 1.5mm ABS edging">' + arrowDefs();
    o += '<defs><pattern id="eg2h" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="8" stroke="#c9d2db" stroke-width="2"/></pattern></defs>';
    // Core with a break line on the left (the worktop continues).
    var zz = 'M' + x + ' ' + y + ' L' + (x + 6) + ' ' + (y + t * .3) + ' L' + (x - 4) + ' ' + (y + t * .6) + ' L' + (x + 4) + ' ' + base;
    o += '<path d="' + zz + ' L' + xr + ' ' + base + ' L' + xr + ' ' + y + ' Z" fill="#f1ede6"/>';
    o += '<path d="' + zz + ' L' + xr + ' ' + base + ' L' + xr + ' ' + y + ' Z" fill="url(#eg2h)" stroke="' + GREY + '"/>';
    o += '<line x1="' + x + '" y1="' + y + '" x2="' + xr + '" y2="' + y + '" stroke="' + INK + '" stroke-width="2.5"/>';
    o += '<rect x="' + xr + '" y="' + y + '" width="' + abs + '" height="' + t + '" fill="' + BLUE + '"/>';
    // Thickness dimension.
    var dx = xr + abs + 26;
    o += '<line x1="' + dx + '" y1="' + y + '" x2="' + dx + '" y2="' + base + '" stroke="' + INK + '" marker-start="url(#eg2a)" marker-end="url(#eg2a)"/>';
    o += '<line x1="' + (xr + abs + 4) + '" y1="' + y + '" x2="' + (dx + 6) + '" y2="' + y + '" stroke="' + GREY + '" stroke-dasharray="3 3"/>';
    o += '<line x1="' + (xr + abs + 4) + '" y1="' + base + '" x2="' + (dx + 6) + '" y2="' + base + '" stroke="' + GREY + '" stroke-dasharray="3 3"/>';
    o += txt(dx + 10, y + t / 2 + 5, d.T + 'mm', { weight: 700, size: 14 });
    // Callouts.
    o += '<line x1="' + (x + 60) + '" y1="' + y + '" x2="' + (x + 60) + '" y2="' + (y - 22) + '" stroke="' + GREY + '"/>' + txt(x + 60, y - 28, 'Decor surface', { size: 14, anchor: 'middle' });
    o += '<line x1="' + (xr + abs / 2) + '" y1="' + y + '" x2="' + (xr + abs / 2) + '" y2="' + (y - 22) + '" stroke="' + GREY + '"/>' + txt(xr + abs / 2, y - 28, '1.5mm ABS, square edge', { size: 14, anchor: 'middle', fill: BLUE });
    o += txt(x + depth / 2, base + 24, 'Front edge, section', { anchor: 'middle', size: 15, weight: 600 });
    o += txt(x + depth / 2, base + 44, two ? 'The back edge is the same.' : 'The back edge is not edged.', { anchor: 'middle', size: 14, fill: '#5a5a5a' });
    o += txt(x + depth / 2, base + 64, 'Drawn to scale; 80mm of the depth shown.', { anchor: 'middle', size: 14, fill: '#5a5a5a' });
    return o + '</svg>';
  }
  function draw() {
    var p = $('[data-eg2-plan]'), e = $('[data-eg2-edge]');
    if (p) p.innerHTML = planSvg();
    if (e) e.innerHTML = edgeSvg();
  }

  /* ---------- Full screen with zoom and pan ---------- */
  var dlg = $('[data-eg2-dialog]'), inner = $('[data-eg2-inner]'), stage = $('[data-eg2-stage]');
  var view = { z: 1, x: 0, y: 0 }, drag = null, opener = null;
  function applyView() { inner.style.transform = 'translate(' + view.x + 'px,' + view.y + 'px) scale(' + view.z + ')'; }
  function openFs(title, html) {
    if (!dlg) return;
    opener = document.activeElement;
    $('[data-eg2-fs-title]').textContent = title;
    inner.innerHTML = html;
    view = { z: 1, x: 0, y: 0 }; applyView();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closeFs() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  if (dlg) {
    dlg.addEventListener('close', function () { inner.innerHTML = ''; if (opener && opener.focus) opener.focus(); });
    $('[data-eg2-close]').addEventListener('click', closeFs);
    $$('[data-eg2-z]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = Number(b.getAttribute('data-eg2-z'));
        if (!f) view = { z: 1, x: 0, y: 0 }; else view.z = Math.min(6, Math.max(1, view.z * f));
        if (view.z === 1) { view.x = 0; view.y = 0; }
        applyView();
      });
    });
    stage.addEventListener('wheel', function (e) { e.preventDefault(); view.z = Math.min(6, Math.max(1, view.z * (e.deltaY < 0 ? 1.15 : 0.87))); applyView(); }, { passive: false });
    stage.addEventListener('pointerdown', function (e) { drag = { x: e.clientX - view.x, y: e.clientY - view.y }; stage.setPointerCapture(e.pointerId); });
    stage.addEventListener('pointermove', function (e) { if (!drag || view.z === 1) return; view.x = e.clientX - drag.x; view.y = e.clientY - drag.y; applyView(); });
    stage.addEventListener('pointerup', function () { drag = null; });
    stage.addEventListener('pointercancel', function () { drag = null; });
  }
  $$('[data-eg2-fs]').forEach(function (b) {
    b.addEventListener('click', function () {
      var plan = b.getAttribute('data-eg2-fs') === 'plan';
      openFs(plan ? 'Plan view' : 'Edge profile', plan ? planSvg() : edgeSvg());
    });
  });
  var zd = $('[data-eg2-zoom-decor]');
  if (zd) zd.addEventListener('click', function () {
    var sw = finishEl();
    if (sw && sw.dataset.img) openFs(sw.dataset.name + ' (' + sw.dataset.code + ')', '<img src="' + esc(sw.dataset.img) + '" alt="' + esc(sw.dataset.name) + ' decor">');
  });

  /* ---------- Selection ---------- */
  function setFinish(value) {
    state.finish = value;
    swatches.forEach(function (b) { var on = b.dataset.value === value; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var sw = finishEl(), box = $('[data-eg2-decor]');
    if (sw && box) {
      var im = $('[data-eg2-decor-img]');
      if (sw.dataset.img) { im.src = sw.dataset.img; im.alt = sw.dataset.name + ' decor'; im.parentNode.hidden = false; } else { im.removeAttribute('src'); im.parentNode.hidden = true; }
      $('[data-eg2-decor-name]').textContent = sw.dataset.name;
      $('[data-eg2-decor-meta]').textContent = 'EGGER decor ' + sw.dataset.code + (sw.dataset.seal ? ' · Matching EGGERSeal: ' + sw.dataset.seal : '');
      box.classList.toggle('is-noimg', !sw.dataset.img);
      box.hidden = false;
    }
    var seal = $('[data-eg2-seal]');
    if (seal && sw) seal.textContent = sw.dataset.seal ? sw.dataset.seal + ' (for ' + sw.dataset.name + ')' : 'Ask us for the matching EGGERSeal colour';
    refresh();
  }
  function setSize(value) {
    state.size = value;
    sizes.forEach(function (b) { var on = b.dataset.value === value; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    refresh();
  }
  function radioKeys(list, pick) {
    list.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b.dataset.value); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = i + 1; else if (k === 'ArrowLeft' || k === 'ArrowUp') j = i - 1; else return;
        e.preventDefault();
        var vis = list.filter(function (x) { return !x.hidden; }), at = vis.indexOf(b), nx = vis[(at + (j > i ? 1 : -1) + vis.length) % vis.length];
        nx.focus(); pick(nx.dataset.value);
      });
    });
  }
  radioKeys(swatches, setFinish);
  radioKeys(sizes, setSize);

  var search = $('[data-eg2-search]');
  if (search) search.addEventListener('input', function () {
    var q = search.value.trim().toLowerCase().replace(/\s+/g, ' '), shown = 0;
    swatches.forEach(function (b) {
      var hay = (b.dataset.name + ' ' + b.dataset.code + ' ' + b.dataset.code.replace(/\s/g, '')).toLowerCase();
      var ok = !q || hay.indexOf(q) !== -1;
      b.hidden = !ok; if (ok) shown++;
    });
    $('[data-eg2-none]').hidden = shown > 0;
  });

  /* ---------- Quantity ---------- */
  var qIn = $('[data-eg2-qty-in]');
  function setQty(n) { state.qty = Math.min(99, Math.max(1, Math.round(Number(n) || 1))); qIn.value = state.qty; refresh(); }
  $$('[data-eg2-qty]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty + Number(b.getAttribute('data-eg2-qty'))); }); });
  qIn.addEventListener('change', function () { setQty(qIn.value); });

  /* ---------- Render ---------- */
  var addBtn = $('[data-eg2-add]'), status = $('[data-eg2-status]'), busy = false;
  function say(msg, err) { status.textContent = msg || ''; status.classList.toggle('is-err', !!err); }
  function refresh() {
    var v = findVariant(), sw = finishEl();
    // Size card prices follow the chosen finish (real variant prices).
    sizes.forEach(function (b) {
      var m = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option2 === b.dataset.value && (!state.finish || variants[i].option1 === state.finish)) { m = variants[i]; break; }
      }
      var el = b.querySelector('[data-eg2-size-price]');
      if (m && el) el.textContent = gbp(m.price) + (m.available ? '' : ' (unavailable)');
    });
    $('[data-eg2-sum-finish]').textContent = sw ? sw.dataset.name + ' (' + sw.dataset.code + ')' : 'Not chosen yet';
    var d = dims(state.size);
    $('[data-eg2-sum-size]').textContent = state.size ? d.L + ' × ' + d.W + 'mm' : 'Not chosen yet';
    $('[data-eg2-sum-edge]').textContent = '1.5mm ABS' + (state.size ? (d.W >= 900 ? ', both long sides' : ', one long side') : '');
    var th = $('[data-eg2-sum-thumb]');
    th.style.backgroundImage = sw && sw.dataset.img ? 'url("' + sw.dataset.img.replace(/"/g, '%22') + '")' : '';
    th.parentNode.classList.toggle('is-noimg', !(sw && sw.dataset.img));
    var price = $('[data-eg2-price]'), inc = $('[data-eg2-price-inc]'), tot = $('[data-eg2-total]');
    if (v) {
      price.textContent = gbp(v.price);
      inc.textContent = gbp(Math.round(v.price * 1.2)) + ' inc VAT';
      tot.hidden = state.qty < 2;
      tot.textContent = state.qty + ' worktops: ' + gbp(v.price * state.qty) + ' exc VAT (' + gbp(Math.round(v.price * state.qty * 1.2)) + ' inc VAT)';
    } else {
      price.textContent = '—'; inc.textContent = 'Choose a finish and size'; tot.hidden = true;
    }
    var ok = !!(v && v.available);
    addBtn.disabled = !ok || busy;
    if (v && !v.available) say('This finish and size is currently unavailable. Request a quote and we will check stock.', true);
    else if (!busy && status.classList.contains('is-err') && ok) say('');
    if (v) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    }
    // Quote email carries the current choice.
    var q = $('[data-eg2-quote]');
    if (q) {
      var base = q.getAttribute('href').split('&body=')[0];
      var body = 'Product: ' + document.title.split(' | ')[0] + '\nDecor: ' + (sw ? sw.dataset.name + ' (' + sw.dataset.code + ')' : '') +
        '\nStock size: ' + (state.size ? d.L + ' x ' + d.W + ' x ' + d.T + 'mm' : '') + '\nSizes I need (length x width, quantity):\nOther work needed:\nDelivery postcode:\n';
      q.setAttribute('href', base + '&body=' + encodeURIComponent(body));
    }
    draw();
    bar();
  }

  /* ---------- Phone steps ---------- */
  var navBtns = $$('.eg2-steps [data-eg2-go]');
  function setStep(n, focus) {
    if (n >= 2 && !state.finish) { n = 1; }
    if (n >= 3 && !state.size) { n = 2; }
    state.step = n;
    root.setAttribute('data-mstep', String(n));
    navBtns.forEach(function (b) {
      var k = Number(b.getAttribute('data-eg2-go'));
      b.classList.toggle('is-on', k === n);
      b.classList.toggle('is-done', (k === 1 && !!state.finish) || (k === 2 && !!state.size));
      if (k === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    bar();
    if (focus && phone.matches) {
      // The step bar is sticky, so measure from the grid below it instead.
      var steps = $('.eg2-steps'), grid = $('.eg2-grid');
      var hd = parseFloat(getComputedStyle(root).getPropertyValue('--eg-hdr')) || 0;
      var top = grid.getBoundingClientRect().top + window.scrollY - hd - steps.offsetHeight - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
      var h = $('[data-eg2-panel="' + n + '"] .eg2-h2');
      if (h) setTimeout(function () { h.focus({ preventScroll: true }); }, 250);
    }
  }
  $$('[data-eg2-go], [data-eg2-next-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Number(b.getAttribute('data-eg2-go') || b.getAttribute('data-eg2-next-step'));
      if (!phone.matches) { var t = $('[data-eg2-panel="' + n + '"]'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      setStep(n, true);
    });
  });
  var barBtn = $('[data-eg2-bar-btn]');
  function bar() {
    var v = findVariant();
    $('[data-eg2-bar-label]').textContent = v ? (state.qty > 1 ? state.qty + ' worktops' : 'Per 4100mm worktop') : 'From';
    if (v) $('[data-eg2-bar-price]').textContent = gbp(v.price * state.qty);
    var s = state.step;
    if (s === 1) { barBtn.textContent = state.finish ? 'Next: choose size' : 'Choose a finish'; barBtn.disabled = !state.finish; }
    else if (s === 2) { barBtn.textContent = state.size ? 'Next: review' : 'Choose a size'; barBtn.disabled = !state.size; }
    else { barBtn.textContent = busy ? 'Adding…' : 'Add to Basket'; barBtn.disabled = !(v && v.available) || busy; }
  }
  barBtn.addEventListener('click', function () {
    if (state.step === 1) setStep(2, true);
    else if (state.step === 2) setStep(3, true);
    else addToCart();
  });
  $$('[data-eg2-quote-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var q = $('.eg2-quote'); if (!q) return;
      if (phone.matches && getComputedStyle(q).display === 'none') setStep(3);
      q.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---------- Basket: the selected variant and quantity, nothing else ---------- */
  function addToCart() {
    var v = findVariant();
    if (!v || !v.available || busy) return;
    busy = true; addBtn.textContent = 'Adding…'; say(''); refresh();
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(v.id), quantity: state.qty }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket. Please try again.');
      });
    }).then(function () {
      say('Added to your basket.');
      if (window.BW && typeof window.BW.openCartDrawer === 'function') return window.BW.openCartDrawer();
      window.location.href = '/cart';
    }).catch(function (err) {
      say(err && err.message ? err.message : 'Could not add to basket. Please try again.', true);
    }).then(function () {
      busy = false; addBtn.textContent = 'Add to Basket'; refresh();
    });
  }
  addBtn.addEventListener('click', addToCart);

  /* Sticky summary and phone step bar sit below the site's sticky header. */
  var hdrRaf = 0;
  function hdr() {
    hdrRaf = 0;
    var b = 0;
    $$('.shopify-section-group-header-group', document).forEach(function (el) {
      var p = getComputedStyle(el).position;
      if (p === 'sticky' || p === 'fixed') { var r = el.getBoundingClientRect(); if (r.top <= 1 && r.bottom > b) b = r.bottom; }
    });
    root.style.setProperty('--eg-hdr', Math.max(0, Math.round(b)) + 'px');
  }
  window.addEventListener('scroll', function () { if (!hdrRaf) hdrRaf = requestAnimationFrame(hdr); }, { passive: true });
  window.addEventListener('resize', hdr);
  hdr();

  /* ---------- Start ---------- */
  var on = swatches.filter(function (b) { return b.classList.contains('is-on'); })[0];
  var onS = sizes.filter(function (b) { return b.classList.contains('is-on'); })[0];
  if (on) setFinish(on.dataset.value);
  if (onS) setSize(onS.dataset.value);
  refresh();
  setStep(1);
})();
